import { useSelector } from 'react-redux'
import { NoResultsMessage } from '~/app/features/Gallery/components/PreviewArea/NoResultsMessage'
import { PreviewList } from '~/app/features/Gallery/components/PreviewArea/PreviewList'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'
import { totalEntityCountSelector } from '~/app/store/paging'
import { QuickViewModal } from '~/app/features/Gallery/components/PreviewArea/QuickViewModal'
import { getShowSpinnerSelector } from '~/app/store/ux'
import { LoadingSpinner } from 'app/components/LoadingSpinner'

export const PreviewArea = () => {
  const localize = useTranslations()
  const resultCount = useSelector(totalEntityCountSelector)
  const { showSpinner } = useSelector(getShowSpinnerSelector)

  return (
    <section aria-label={localize('PreviewRegionLabel')} className="preview-area-container" id="preview-area">
      {!resultCount && <NoResultsMessage key="no-results-message" />}
      {!!resultCount && <PreviewList />}
      <QuickViewModal />
      {showSpinner && <LoadingSpinner />}
    </section>
  )
}
